import React from "react";
import { Button } from "react-bootstrap";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import ProtectedButton from "../RBAC/ProtectedButton";

export default function ProposalCard({ proposalFile, onAccept, onReject }) {
    return (
        <div
            className="d-flex align-items-center justify-content-between border rounded-4 p-3 shadow-sm bg-white"
            style={{
                minWidth: "500px",
                borderColor: "#E0E0E0",
            }}
        >
            {/* Left section: Icon + Text */}
            <div className="d-flex align-items-start gap-3">
                {/* Icon */}
                <div
                    className="d-flex align-items-center justify-content-center rounded-circle"
                    style={{
                        backgroundColor: "#F6F9FF",
                        width: "48px",
                        height: "48px",
                    }}
                >
                    <img
                        src="/images/proposal.svg"
                        alt="proposal"
                        width={26}
                        height={26}
                    />
                </div>

                {/* Text */}
                <div>
                    <div className="fw-semibold text-dark">You have got a proposal</div>
                    {proposalFile?.fileUrl ? (
                        <a
                            href={proposalFile?.fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-danger text-decoration-underline small fw-semibold"
                        >
                            {proposalFile?.fileName}
                        </a>
                    ) : (
                        <div className="text-muted small">{proposalFile?.fileName}</div>
                    )}
                </div>
            </div>

            {/* Right section: Actions */}
            <div className="d-flex align-items-center gap-2">
                <ProtectedButton
                    permission="manageProposal"
                    variant="outline-secondary"
                    size="sm"
                    className="rounded-3 px-4 py-2 fw-medium"
                    onClick={onReject}
                >
                    Reject
                </ProtectedButton>
                <ProtectedButton
                    permission="manageProposal"
                    className="btn btn-dark text-white"
                    style={{ backgroundColor: "#181D4C", border: "none" }}
                    onClick={onAccept}
                >
                    Accept
                </ProtectedButton>
            </div>
        </div>
    );
}
